/*
Plugin that will display a notification to the user if their browser does not support the Corrector.
*/
class CorrectorUnsupportedPlugin extends CorrectorPlugin {


	properties() {
		super.properties();

		// message sets the message displayed in the browser.
		this.options.message = Corrector._t("Sorry your current browser does not support the Corrector");
	}

	/*
	Public: Checks the Corrector.supported() method and if unsupported displays @options.message in a notification.
	Returns nothing.
	*/

	pluginInit() {
		if (!Corrector.supported()) {
			$(() => {
				// On document load display notification.
				Corrector.showNotification(this.options.message);

				// Add a class if we're in IE6. A bit of a hack but we need to be able
				// to set the notification position in the CSS.
				if ((window.XMLHttpRequest === undefined) && (ActiveXObject !== undefined)) {
					$('html').addClass('ie6');
				}
			});
		}
	}

}
CorrectorPlugin.Unsupported = CorrectorUnsupportedPlugin;